import AuthContainer from '@/components/auth/AuthContainer';
import ResendConfirmationCodeForm from '@/components/auth/ResendConfirmationCodeForm';
import TermsAndConditions from '@/components/auth/legal-links/TermsAndConditions';
import { useAuthProvider } from '@/hooks/auth/useAuthProvider';

export default function ResendConfirmationCode() {
	const { handleResendConfirmationCode, loadingState } = useAuthProvider();
	return (
		<AuthContainer>
			<div className="flex flex-col items-center justify-center h-full w-full p-8 mt-8">
				<div className="bg-white rounded-2xl glassy-shadow-inset-outward p-8 w-full h-2/3 flex items-center justify-center">
					<div className="w-full flex flex-col items-center justify-center">
						<p className="text-2xl text-center mb-6 mt-2 font-bold">
							Resend Code
						</p>

						<div className="w-full max-w-sm">
							<ResendConfirmationCodeForm
								handleSubmit={handleResendConfirmationCode}
								loading={loadingState.resendConfirmationCode}
							/>
						</div>
					</div>
				</div>
				<div className="w-full max-w-sm text-center mt-4">
					<TermsAndConditions />
				</div>
			</div>
		</AuthContainer>
	);
}
